import { useState, useEffect, useRef } from "react";
const SelectBoxWithSeach = ({
  id,
  label,
  options = [],
  value,
  onChange,
  required,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const filteredOptions = options.filter((option) =>
    option?.Name?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const selectedName =
    options.find((opt) => opt.Id === value)?.Name || "-- Select --";
  return (
    <div className="form-floating position-relative" ref={dropdownRef}>
      {/* Input box (mimics select) */}
      <div
        className="form-select d-flex align-items-center"
        onClick={() => setIsOpen(!isOpen)}
        style={
          isOpen
            ? {
                cursor: "pointer",
                minHeight: "40px",
                borderRadius: "0.25rem  0.25rem 0rem 0rem",
              }
            : { cursor: "pointer", minHeight: "40px" }
        }
      >
        {selectedName}
      </div>
      <label htmlFor={id}>
        {label}
        {required && <strong className="text-danger fs-9 ms-1">*</strong>}
      </label>
      {/* Dropdown */}
      {isOpen && (
        <div
          className="position-absolute bg-white border w-100 shadow-sm"
          style={{ zIndex: 98, maxHeight: "250px", overflowY: "auto" }}
        >
          <input
            type="text"
            className="form-control border-0 border-bottom rounded-0"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, idx) => (
              <div
                key={idx}
                className="px-3 py-2 hover-item"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  onChange({ target: { value: option.Id, id: id } });
                  setIsOpen(false);
                  setSearchTerm("");
                }}
              >
                {option.Name}
              </div>
            ))
          ) : (
            <div className="px-3 py-2 text-muted">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectBoxWithSeach;
